var v = /* @__PURE__ */ ((i) => (i.Inclusive = "inclusive", i.Exclusive = "exclusive", i))(v || {});
export {
  v as TaxBehaviorEnum
};
